module.exports = __webpack_public_path__ + "img/Hanssen.0afdaef8.jpg";